
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getEligibilityStatusAfterPusherEvent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"clientId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"client"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"clientId"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"latestClientEligibilityStatus"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"currentStep"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"policyStatus"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"policyMetadata"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"serviceEligibilityStatus"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"serviceEligibilityMetadata"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"eligibilityParams"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"person"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lastName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"dateOfBirth"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"state"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"payerId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"serviceTypeId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"memberId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"skipMembershipId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"onlySoftCheck"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"clinicalInfo"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"diagnoses"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"retryCount"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":612}};
    doc.loc.source = {"body":"query getEligibilityStatusAfterPusherEvent($clientId: ID!) {\n  client(id: $clientId) {\n    id\n    latestClientEligibilityStatus {\n      id\n      currentStep\n      policyStatus\n      policyMetadata\n      serviceEligibilityStatus\n      serviceEligibilityMetadata\n      eligibilityParams {\n        person {\n          firstName\n          lastName\n          dateOfBirth\n        }\n        location {\n          state\n        }\n        payerId\n        serviceTypeId\n        memberId\n        skipMembershipId\n        onlySoftCheck\n        clinicalInfo {\n          diagnoses\n        }\n      }\n      retryCount\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["getEligibilityStatusAfterPusherEvent"] = oneQuery(doc, "getEligibilityStatusAfterPusherEvent");
        
